import {
	forwardRef,
	ReactElement,
	Ref
} from "react";
import { UserIdentityModel } from "client/Api/UserProfile/service";
import styles from "./MobileComment.module.less";
import { MobileCommentHeader } from "./MobileCommentHeader/MobileCommentHeader";
import { MobileCommentForm } from "./MobileCommentForm/MobileCommentForm";
import { isNotNil, setTrackingId } from "client/Misc/utils";
import {
	HubCommentMediaPreviewModel,
	HubCommentModel,
	UserMentionViewModel
} from "client/Api/Hub/common";
import { HubCommentSectionService } from "../HubCommentSection";
import { HubCommentOptionsModel } from "client/Api/Hub/common.details";
import classNames from "classnames";

export type MobileCommentMode = { header?: string; } & ({
	kind: "create";
} |
{
	kind: "edit";
	message: string;
	mentions: readonly UserMentionViewModel[];
	commentId: number;
	authorUserInfo: UserIdentityModel;
	media: HubCommentMediaPreviewModel | null;
} |
{
	kind: "reply";
	parentCommentId: number;
	replyCommentId: number;
	authorUserInfo: UserIdentityModel;
});

export type MobileCommentFormHandle = {
	focusInput(): void;
};

export type MobileCommentProps = {
	onCreated?: (comment: HubCommentModel) => void;
	onCancel: () => void;
	onUpdated: (comment: HubCommentModel) => void;
	onMobileCommentIsEditingChanged: (isEditing: boolean) => void;
	position?: "bottom" | "inline";
	service: HubCommentSectionService;
	currentUserInfo: UserIdentityModel;
	mode: MobileCommentMode;
	options: HubCommentOptionsModel;
};

export const MobileComment = forwardRef(
	(
		props: MobileCommentProps,
		ref: Ref<MobileCommentFormHandle>
	): ReactElement => {
		const {
			service,
			currentUserInfo,
			mode,
			options,
			position = "bottom",
			onCreated,
			onCancel,
			onUpdated,
			onMobileCommentIsEditingChanged
		} = props;

		return (
			<div
				{...setTrackingId("mobile-comment")}
				className={classNames(
					{
						[styles.root_bottom]: position === "bottom"
					}
				)}
			>
				<div className={styles.commentBoxContainer}>
					<div className={styles.shadowContainer}>
						<div>
							{isNotNil(mode.header) && (
								<MobileCommentHeader
									header={mode.header}
									onCancel={onCancel}
								/>
							)}
							<MobileCommentForm
								mode={mode}
								service={service}
								currentUserInfo={currentUserInfo}
								onUpdated={onUpdated}
								onMobileIsEditingChanged={onMobileCommentIsEditingChanged}
								ref={ref}
								onCreated={onCreated}
								commentOptions={options}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
);

MobileComment.displayName = "MobileComment";
